import {
    AbstractControl,
    AsyncValidatorFn,
    ValidationErrors,
  } from '@angular/forms';
  import { Observable } from 'rxjs';
  import { map } from 'rxjs/operators';
import { UsersService } from '../services/users.service';
import { AuthService } from '../services/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
  //import { UserService } from './user.service';
  
  export class UsernameValidator {
    static createValidator(userService: UsersService, authService: AuthService, http: HttpClient): AsyncValidatorFn {
      return (control: AbstractControl): Observable< any> => {
        //return (control: AbstractControl): Observable<ValidationErrors> => {

        const endpoint = environment.apiUrl + "/api/users/checkIfExists/" + control.value;
        const bearerToken = "Bearer " + authService.getToken()


        return http.get(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken) })
        .pipe(
            map((result: any) =>
              result.exists == true ? { usernameAlreadyExists: true } : null
            )
          );
      };
    }
  }
  